/**
 * Canonical region + service-type lists for SPA forms (BUILD_SPEC.md
 * §10.7, §10.8). Mirrors the source-of-truth list on the API
 * (apps/api/src/lib/regions.ts) — keeping a separate copy avoids a
 * shared-package dependency at the cost of two-place maintenance.
 *
 * If a value is added or renamed, update both files at once. The API
 * is authoritative; the SPA copy here only drives the dropdown
 * options on the create form, and the server validates anyway.
 */

export const CANONICAL_REGIONS = [
  "المدينة",
  "بسمان",
  "ماركا",
  "النصر",
  "اليرموك",
  "راس العين",
  "بدر",
  "زهران",
  "العبدلي",
  "طارق",
  "القويسمة",
  "خربة السوق",
  "المقابلين والبنيات",
  "وادي السير",
  "بدر الجديدة",
  "صويلح",
  "تلاع العلي",
  "الجبيهه",
  "شفابدران",
  "ابونصير",
  "احد",
  "مرج الحمام",
  "مركز سلمى ارشغة",
  "مركز مؤته ارشغة",
] as const;

export const CANONICAL_SERVICE_TYPES = [
  "ترخيص زيادات",
  "تصحيح وثيقة تجديد اذن الاشغال",
  "تصحيح وثيقة اذن الاشغال",
  "اعادة النظر بقرار لجنة التخطيط المركزية (اللوائية)",
  "ترخيص مساحات قائمة و إذن اشغال",
  "الاستشارة (موافقة مبدئية)",
  "ترخيص مقترح على ارض خالية",
  "ترخيص مقترح فوق قائم",
  "بناء قائم لأول مرة",
  "ترخيص مخطط تعديلي",
  "اذن اشغال",
  "الغاء ترخيص مقترح",
  "تجديد اذن اشغال",
] as const;
